import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import styles from "./Authenticate.module.scss";
import { FloatingPanel } from "../../common/components/common/FloatingPanel/FloatingPanel";
import { AuthenticationForm } from "../../common/components/authentication/AuthenticationForm/AuthenticationForm";
import { UserPhoneCheckStatus } from "../../common/enums";
import {
  buildLoginPathWithReturnUrl,
  getSafeReturnUrl,
} from "../../common/infrastructure/utilities/returnUrlUtility";

const getTitle = (status: UserPhoneCheckStatus | undefined): string => {
  switch (status) {
    case UserPhoneCheckStatus.BrandNew:
      return "Регистрация";
    case UserPhoneCheckStatus.FirstLogin:
      return "Първи вход";
    case UserPhoneCheckStatus.PendingVerification:
      return "Потвърждаване на имейл";
    default:
      return "Вход или регистрация";
  }
};

export const Authenticate = () => {
  const [status, setStatus] = useState<UserPhoneCheckStatus>();
  const [searchParams] = useSearchParams();
  // The private page that sent a logged-out visitor here (see PrivateRoutesOutlet).
  const returnUrl = getSafeReturnUrl(searchParams.get("returnUrl"));
  // Google comes back to this public page, not the private one, which would bounce a visitor
  // who is not logged in yet; the Google login then goes on to returnUrl.
  const googleReturnUrl = returnUrl ? buildLoginPathWithReturnUrl(returnUrl) : undefined;

  return (
    <FloatingPanel
      className={styles.panel}
      title={getTitle(status)}
      variant="glass"
    >
      <div className={styles.panel_overflow}>
        <AuthenticationForm
          formClassName={styles.root_form}
          fieldsClassName={styles.panel_fields}
          buttonClassName={styles.root_button}
          googleButtonClassName={styles.google_login_button}
          onStatusChange={setStatus}
          returnUrl={returnUrl}
          googleReturnUrl={googleReturnUrl}
        />
      </div>
    </FloatingPanel>
  );
};
